import { Login as DLLogin } from './../DL/Login'

import { ValidateSqlInjection } from './Security'


const Login = async (username, password) => {
    try {
        if (!username || username === '') {
            return { success: false, message: 'Escribe tu usuario' }
        }

        if (!password || password === '') {
            return { success: false, message: 'Escribe tu contraseña' }
        }

        const isUsernameWrong = await ValidateSqlInjection(username)
        if (isUsernameWrong) {
            return { success: false, message: 'El usuario que escribiste no es válido' }
        }

        const isPasswordWrong = await ValidateSqlInjection(password)
        if (isPasswordWrong) {
            return { success: false, message: 'La contraseña que escribiste no es válida' }
        }

        const response = await DLLogin(username, password)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar iniciar sesión. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

export { Login };